<template>
  <div id="MyHealthHandover">
    <template v-if="handoverPageData">
      <div class="my-health-handover-top">
        <GoBackBtn />
      </div>
      <div class="my-health-handover-main">
        <img
          :src="`/img/my-health/${handoverPageData.icon}.png`"
          :alt="handoverPageData.title"
          class="my-health-handover-img"
        />
        <h2 class="my-health-handover-title brand-highlight-3">
          {{ handoverPageData.title }}
        </h2>
        <h3 class="my-health-handover-subtitle">
          {{ handoverPageData.provided_by }}
        </h3>
        <p class="my-health-handover-paragraph brand-highlight-3">
          {{ handoverPageData.description }}
        </p>
        <MyHealthAccordion :accordionData="accordionData" />

        <template v-if="isContinueToBooking">
          <b-button variant="continue" @click="redirectToNextPage">
            {{ handoverPageData.cta_label }}
          </b-button>
        </template>
        <template v-else-if="isDownloadApp">
          <a
            :href="handoverPageData.partner_link_ios"
            target="_blank"
            class="btn btn-continue"
          >
            {{ handoverPageData.cta_label }} in App Store
            <svg
              class="icon-arrow ml-2"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 0L15 0C15.5312 0 16 0.46875 16 1V6C16 6.5625 15.5312 7 15 7C14.4375 7 14 6.5625 14 6V3.4375L7.6875 9.71875C7.3125 10.125 6.65625 10.125 6.28125 9.71875C5.875 9.34375 5.875 8.6875 6.28125 8.3125L12.5625 2L10 2C9.4375 2 9 1.5625 9 1C9 0.46875 9.4375 0 10 0ZM2.5 1L6 1C6.53125 1 7 1.46875 7 2C7 2.5625 6.53125 3 6 3L2.5 3C2.21875 3 2 3.25 2 3.5L2 13.5C2 13.7812 2.21875 14 2.5 14H12.5C12.75 14 13 13.7812 13 13.5V10C13 9.46875 13.4375 9 14 9C14.5312 9 15 9.46875 15 10V13.5C15 14.9062 13.875 16 12.5 16H2.5C1.09375 16 0 14.9062 0 13.5L0 3.5C0 2.125 1.09375 1 2.5 1Z"
                fill="currentColor"
              />
            </svg>
          </a>
          <a
            :href="handoverPageData.partner_link_android"
            target="_blank"
            class="btn btn-continue"
          >
            {{ handoverPageData.cta_label }} in Google Play
            <svg
              class="icon-arrow ml-2"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 0L15 0C15.5312 0 16 0.46875 16 1V6C16 6.5625 15.5312 7 15 7C14.4375 7 14 6.5625 14 6V3.4375L7.6875 9.71875C7.3125 10.125 6.65625 10.125 6.28125 9.71875C5.875 9.34375 5.875 8.6875 6.28125 8.3125L12.5625 2L10 2C9.4375 2 9 1.5625 9 1C9 0.46875 9.4375 0 10 0ZM2.5 1L6 1C6.53125 1 7 1.46875 7 2C7 2.5625 6.53125 3 6 3L2.5 3C2.21875 3 2 3.25 2 3.5L2 13.5C2 13.7812 2.21875 14 2.5 14H12.5C12.75 14 13 13.7812 13 13.5V10C13 9.46875 13.4375 9 14 9C14.5312 9 15 9.46875 15 10V13.5C15 14.9062 13.875 16 12.5 16H2.5C1.09375 16 0 14.9062 0 13.5L0 3.5C0 2.125 1.09375 1 2.5 1Z"
                fill="currentColor"
              />
            </svg>
          </a>
        </template>
        <template v-else>
          <a
            :href="handoverPageData.partner_link"
            target="_blank"
            class="btn btn-continue"
          >
            {{ handoverPageData.cta_label }}
            <svg
              class="icon-arrow ml-2"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 0L15 0C15.5312 0 16 0.46875 16 1V6C16 6.5625 15.5312 7 15 7C14.4375 7 14 6.5625 14 6V3.4375L7.6875 9.71875C7.3125 10.125 6.65625 10.125 6.28125 9.71875C5.875 9.34375 5.875 8.6875 6.28125 8.3125L12.5625 2L10 2C9.4375 2 9 1.5625 9 1C9 0.46875 9.4375 0 10 0ZM2.5 1L6 1C6.53125 1 7 1.46875 7 2C7 2.5625 6.53125 3 6 3L2.5 3C2.21875 3 2 3.25 2 3.5L2 13.5C2 13.7812 2.21875 14 2.5 14H12.5C12.75 14 13 13.7812 13 13.5V10C13 9.46875 13.4375 9 14 9C14.5312 9 15 9.46875 15 10V13.5C15 14.9062 13.875 16 12.5 16H2.5C1.09375 16 0 14.9062 0 13.5L0 3.5C0 2.125 1.09375 1 2.5 1Z"
                fill="currentColor"
              />
            </svg>
          </a>
        </template>

        <p class="my-health-handover-info brand-highlight-3">
          {{ handoverPageData.small_print }}
        </p>
      </div>
    </template>
    <ServiceNotFound v-else-if="services && !services.length || isServiceNotFound" />
    <Loader v-else-if="!services" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import GoBackBtn from "../components/MyHealth/GoBackBtn.vue";
import MyHealthAccordion from "../components/MyHealth/MyHealthAccordion.vue";
import ServiceNotFound from "../components/TMH/ServiceNotFound.vue";
import Loader from "@/components/Loader.vue";
import EventBus from "@/helpers/eventbus";
import { getCoachingData } from "@/utils/coachingUtils";

export default {
  name: "MyHealthHandover",
  components: {
    GoBackBtn,
    MyHealthAccordion,
    ServiceNotFound,
    Loader
  },
  data() {
    return {
      handoverPageData: null,
      hasCoach: null,
      isServiceNotFound: null,
    };
  },
  mounted() {
    this.setHandoverPageData();
    this.scrollToTop();
  },
  computed: {
    ...mapState(["handoverPage", "services"]),
    passedAreaId() {
      return this.$route.params.areaId;
    },
    passedServiceId() {
      return this.$route.params.serviceId;
    },
    isContinueToBooking() {
      return this.handoverPage.provided_by === "Provided by Spectrum.Life";
    },
    isDownloadApp() {
      return this.handoverPage.partner_link_ios && this.handoverPage.partner_link_android
    },
    isTHMJourney() {
      return ['mhc', 'slm'].includes(this.handoverPageData?.service_type)
    },
    isLearnMoreFAQ() {
      return ['In-the-moment confidential support', 'Financial & Legal advice'].includes(this.handoverPage?.title)
    },
    isLiveChatButtonShown() {
      return ['In-the-moment confidential support'].includes(this.handoverPage?.title)
    },
    isSpectrumFAQ() {
      return this.handoverPage?.faq_link === 'https://spectrum.life'
    },
    accordionData() {
      const accordionArray = [];

      if (this.handoverPage.how_it_works) {
        accordionArray.push({
          title: "How it works",
          content: this.handoverPage?.how_it_works,
          redirectTo: null,
          defaultLink: null,
        });
      }

      if (this.handoverPage.faq_link) {
        accordionArray.push({
          title: "FAQs",
          content: null,
          redirectTo: this.isLearnMoreFAQ ? '/learn-more' :  this.isSpectrumFAQ ? '/faqs' : null,
          defaultLink: this.handoverPage?.faq_link,
          isOpenInSameTab: this.isLearnMoreFAQ,
        });
      }

      if (this.handoverPage.related_content && this.handoverPage.related_content.length > 0) {
        accordionArray.push({
          title: "Related content",
          content: null,
          redirectTo: null,
          defaultLink: null,
          videoData: this.handoverPage.related_content,
        })
      }
      return accordionArray;
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    setHandoverPageData() {
      if (this.handoverPage) {
        this.handoverPageData = this.handoverPage;
      } else if (this.services) {
        const healthAreaData = this.services.find(service => {
          return service.id === this.passedAreaId;
        });

        const servicePage = healthAreaData.service_pages.find(servicePage => {
          return servicePage.simplyhealth_id === this.passedServiceId;
        });

        if (servicePage) {
          this.handoverPageData = servicePage?.handover_page;
          this.$store.dispatch("updateServicePage", servicePage);
          this.$store.dispatch("updateHandoverPage", this.handoverPageData);
        } else {
          this.isServiceNotFound = true
        }
      }
    },
    async redirectToNextPage() {
      EventBus.$emit('toggleLiveChat', this.isLiveChatButtonShown)
      if (this.isTHMJourney) {
        const { hasCoach } = await getCoachingData();
        this.hasCoach = hasCoach;
        const route = this.hasCoach ? "/coaching-platform" : "/session-booking"
        this.$router.push(route);
      } else {
        this.$router.push("/session-booking");
      }
    },
  },
  watch: {
    services: "setHandoverPageData"
  }
};
</script>

<style lang="less">
#MyHealthHandover {
  min-height: 100%;
  background-color: #fff;
  padding: 0 24px 40px;
  font-family: "PlusJakartaSansBold";

  .my-health-handover-top {
    padding: 24px 0;
  }

  .my-health-handover-main {
    max-width: 540px;
    margin: 0 auto;
    border: 1px solid #e0e5f5;
    border-radius: 16px;
    padding: 24px 28px;
    text-align: center;
  }

  .my-health-handover-title {
    font-family: "PlusJakartaSansExtraBold";
    font-size: 2.6rem;
    margin: 0 0 8px 0;
  }

  .my-health-handover-subtitle {
    color: #009577;
    font-size: 1.8rem;
    margin-bottom: 20px;
    padding: 0;
    letter-spacing: 0;
  }

  .my-health-handover-info {
    font-family: "PlusJakartaSansRegular";
    font-weight: 400;
    margin-bottom: 28px;
  }

  .my-health-handover-paragraph {
    font-family: "PlusJakartaSansRegular";
    font-weight: 400;
    font-size: 1.8rem;
    margin-bottom: 8px;
  }

  .my-health-handover-info {
    font-size: 1.4rem;
  }

  .my-health-handover-img {
    width: 120px;
    height: 120px;
    object-fit: contain;
    margin-bottom: 20px;
  }

  .btn {
    font-family: "PlusJakartaSansBold";
  }
}
</style>
